import {Input} from "./Input.js";
import {InputErrorHandler} from "../../util/input-error-handler/index.js";
import {InputValidator} from "../../util/input-validate/inputValidation.js";


export class EmailInput extends Input {

    template() {
        const {addClass = "", inputId = "emailInput"} = this.$props;
        return `
            <input id="${inputId}"
                                type="text" placeholder="${i18next.t(dictionary.email)}"
                                autocomplete="off"
                                data-required-yn='Y' 
                                data-uppercase-yn = 'N'
                                maxlength="50"  
                                data-valid="email"
                                data-in-valid-letter-case-msg = "${i18next.t(common.capitalOnly, {val: $t(dictionary.email)})}"
                                data-empty-msg="${i18next.t(login.common.enter, { val : $t(dictionary.email)})}"  
                                data-un-valid-msg="${i18next.t(login.invalidEmail)}"  class="${addClass} company-email-input">
            <p class="error-txt-wrap">
                <span class="js-error-txt"></span>
            </p>`
    }


    getInputSelector() {
        const {inputId = "emailInput"} = this.$props;
        return `#${inputId}`
    }

    keyUpEventHandlerOfInput(e) {
        const {
            isLast = false,
            submit = Mutil.noop
        } = this.$props;
        if (Mutil.isAvailableKeyCode(e)) {
            return;
        }

        if (isLast && Mutil.isKey(e, "ENTER")) {
            submit();
            return;
        }

        const $emailInput = $("#emailInput");
        InputErrorHandler.removeBlank($emailInput);
        InputErrorHandler.unActiveErrorModeAboutInput($emailInput);
        this.changeUpperCase();

    }

    changeUpperCase() {
        const $emailInput = $("#emailInput");
        if (!InputValidator.checkContainUpperCase($emailInput.val())) {
            return
        }
        InputErrorHandler.changeUpperCase2Lowercase($emailInput);
        InputErrorHandler.activeErrorModeAboutInput($emailInput, i18next.t(common.capitalOnly, {val: $t(dictionary.email)}));
    }
}